export enum AnimationName {
  SlideOnFade = 'slide-on-fade',
  Fade = 'fade',
  Slide = 'slide',
}

export type AnimationNameValues = `${AnimationName}`
